import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const FetchPrograms = graphql(`
    query FetchPrograms($filter: ProgramFilteringRule, $pagination: Pagination, $sort: ProgramSortingRule) {
        programs(filter: $filter, pagination: $pagination, sort: $sort) {
            count
            items {
                ...ProgramListItemData
            }
        }
    }
`);

export const DeleteProgramMutation = graphql(`
    mutation DeleteProgram($id: ObjectID!) {
        deleteProgram(id: $id) {
            __typename
            ... on DeleteProgramSuccessfulResponse {
                success
                deletedId
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const DeleteAssessmentRunsMutation = graphql(`
    mutation DeleteAssessmentRuns($programId: ObjectID!, $groupId: ObjectID!) {
        deleteAssessmentRuns(programId: $programId, groupId: $groupId) {
            __typename
            ... on DeleteAssessmentRunsSuccessfulResponse {
                success
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const ProgramListItemData = graphql(`
    fragment ProgramListItemData on Program {
        id
        name
        description
        companyId
        createdAt
        updatedAt
        courseInstanceId
        courseInstance {
            id
            name
            description
            duration {
                value
                unit
            }
        }
        occurrence
        assessmentRunIds
        assessmentRuns {
            ...AssessmentRunData
        }
    }
`);

const AssessmentRunData = graphql(`
    fragment AssessmentRunData on AssessmentRun {
        id
        name
        groupId
        group {
            id
            name
        }
        status
        startDate
        endDate
        createdAt
        updatedAt
    }
`);

type ProgramListItemDataFragment = ResultOf<typeof ProgramListItemData>;
export type Duration = NonNullable<ProgramListItemDataFragment['courseInstance']>['duration'];
